import classNames from 'classnames';

import type { FC, PropsWithChildren } from 'react';
import React from 'react';

import styles from './styles.module.scss';

interface ErrorMessageProps {
  className?: string,
}

const ErrorMessage: FC<PropsWithChildren<ErrorMessageProps>> = ({
  children,
  className,
}) => {
  const cn = classNames(styles.error, className);
  return (
    <div className={cn}>
      {children}
    </div>
  );
};

export default ErrorMessage;
